// Common constants and configurations for KPI Dashboard

export const KPI_DASHBOARD_ROUTE_ID = 38;

// API endpoints
export const API_ENDPOINTS = {
    GET_MY_PERIODS: '/kpi/period/my-kpi-periods',
    GET_MY_KPI_BY_PERIOD: '/kpi/user-kpi/my-kpi/get/period',
    GET_EMPLOYEE_PREVIEW: '/employee/get/all/preview-role-based'
};

// Chart colors for consistent theming
export const CHART_COLORS = {
    primary: '#1976d2',
    secondary: '#dc004e',
    success: '#4caf50',
    warning: '#ff9800',
    error: '#f44336',
    info: '#2196f3',
    goals: ['#1976d2', '#dc004e', '#4caf50', '#ff9800', '#f44336', '#2196f3', '#9c27b0', '#ff5722'],
    performance: {
        excellent: '#4caf50',
        good: '#8bc34a',
        average: '#ffeb3b',
        poor: '#ff9800',
        critical: '#f44336'
    }
};

// Score ranges for performance indicators
export const SCORE_RANGES = {
    excellent: { min: 9, max: 10, color: '#4caf50', label: 'Excellent' },
    good: { min: 7, max: 8.9, color: '#8bc34a', label: 'Good' },
    average: { min: 5, max: 6.9, color: '#ffeb3b', label: 'Average' },
    poor: { min: 3, max: 4.9, color: '#ff9800', label: 'Needs Improvement' },
    critical: { min: 0, max: 2.9, color: '#f44336', label: 'Critical' }
};

// Dashboard sections configuration
export const DASHBOARD_SECTIONS = {
    OVERVIEW: 'overview',
    PERFORMANCE: 'performance',
    GOALS: 'goals',
    PROGRESS: 'progress',
    DETAILS: 'details'
};

// Error message extraction utility
export const getErrorMessage = (error, defaultMessage) => {
    // Prioritize API response message if it's a string
    if (error?.response?.data?.message && typeof error.response.data.message === 'string') {
        return error.response.data.message;
    }
    // Fall back to error message
    if (error?.message) {
        return error.message;
    }
    // Use default message
    return defaultMessage;
};